import { createContext, useContext } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const PopperZIndexContext = /*#__PURE__*/ createContext(undefined);
export function PopperZIndexProvider(props) { return /*#__PURE__*/ _jsx(PopperZIndexContext.Provider, { value: props.value, children: props.children }); }
export function usePopperZIndex() { return useContext(PopperZIndexContext); }
